import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/app/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { buildHTMLStyles } from './utils/build-styles.mjs';
import { isCSSVariable } from '../dom/utils/is-css-variable.mjs';
import { transformProps } from './utils/transform.mjs';
import { scrapeMotionValuesFromProps as _scrapeMotionValuesFromProps } from './utils/scrape-motion-values.mjs';
import { renderHTML } from './utils/render.mjs';
import { getDefaultValueType } from '../dom/value-types/defaults.mjs';
import { measureViewportBox } from '../../projection/utils/measure.mjs';
import { DOMVisualElement } from '../dom/DOMVisualElement.mjs';
function getComputedStyle(element) {
  return window.getComputedStyle(element);
}
var HTMLVisualElement = /*#__PURE__*/function (_DOMVisualElement) {
  _inherits(HTMLVisualElement, _DOMVisualElement);
  var _super = _createSuper(HTMLVisualElement);
  function HTMLVisualElement() {
    _classCallCheck(this, HTMLVisualElement);
    return _super.apply(this, arguments);
  }
  _createClass(HTMLVisualElement, [{
    key: "readValueFromInstance",
    value: function readValueFromInstance(instance, key) {
      if (transformProps.has(key)) {
        var defaultType = getDefaultValueType(key);
        return defaultType ? defaultType.default || 0 : 0;
      } else {
        var computedStyle = getComputedStyle(instance);
        var value = (isCSSVariable(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
        return typeof value === "string" ? value.trim() : value;
      }
    }
  }, {
    key: "measureInstanceViewportBox",
    value: function measureInstanceViewportBox(instance, _ref) {
      var transformPagePoint = _ref.transformPagePoint;
      return measureViewportBox(instance, transformPagePoint);
    }
  }, {
    key: "build",
    value: function build(renderState, latestValues, options, props) {
      buildHTMLStyles(renderState, latestValues, options, props.transformTemplate);
    }
  }, {
    key: "scrapeMotionValuesFromProps",
    value: function scrapeMotionValuesFromProps(props) {
      return _scrapeMotionValuesFromProps(props);
    }
  }, {
    key: "renderInstance",
    value: function renderInstance(instance, renderState, styleProp, projection) {
      renderHTML(instance, renderState, styleProp, projection);
    }
  }]);
  return HTMLVisualElement;
}(DOMVisualElement);
export { HTMLVisualElement, getComputedStyle };